import React from 'react';
import { connect } from 'react-redux';
import { GiftPdpDispatch, GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { ColorChoice } from '@gift-variable-plugins/color-attribute-shared/ColorAttributeOptions';
import { selectChosenColorById, selectColorChoicesById, selectComponentById, updateValueByIds } from './_redux';
import { ColorAttributeDropdown } from './dropdown/ColorAttributeDropdown';
import { ColorAttributeRadioGroup } from './radio-group/ColorAttributeRadioGroup';

const _ColorAttributeInputControl = ({ component, ...rest }: Props) => {
    if (component === 'dropdown') {
        return <ColorAttributeDropdown {...rest} />;
    } else {
        return <ColorAttributeRadioGroup {...rest} />;
    }
};

type Props = {
    selected: ColorChoice;
    choices: ColorChoice[];
    update: (value: string) => void;
    variableIds: string[];
    component?: 'dropdown' | 'radio-group';
};

const mapStateToProps = (state: GiftPdpState, ownProps: { variableIds: string[] }) => ({
    choices: selectColorChoicesById(state, ownProps.variableIds[0])!,
    selected: selectChosenColorById(state, ownProps.variableIds[0])!,
    component: selectComponentById(state, ownProps.variableIds[0])
});

const mapDispatchToProps = (dispatch: GiftPdpDispatch, ownProps: { variableIds: string[] }) => ({
    update: (color: string) => dispatch(updateValueByIds(ownProps.variableIds, color))
});

export const ColorAttributeInputControl = connect(
    mapStateToProps,
    mapDispatchToProps
)(_ColorAttributeInputControl);